module.exports = __webpack_public_path__ + "static/img/book5.031555f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/book5.jpg
// module id = yWpU
// module chunks = 0